<template>
    <div class="dialog draggable-item bg-light light center text-small w-100-sm w-100-md w-75-lg w-50-xl" v-cloak v-on:keyup.esc="$root.$emit('CLOSESERVICEACCOUNTDIALOG')">

        <DialogTitle :title="serviceAccount.id == null ? $t('Add Service Account') : serviceAccount.name"
            :defaultTitle="serviceAccount.id == null ? $t('Add Service Account') : $t('Edit/Test Service Account')"
            :subTitle="serviceAccount.type_name" @closeDialog="$root.$emit('CLOSESERVICEACCOUNTDIALOG')" />


        <div class="dialog-content overflow bg-light">

            <!--------------------------FORM--------------------------------------------->

            <div class="form-group">
                <label>{{ $t("Name") }}*</label>
                <input data-role="input" type="text" v-model.trim="serviceAccount.name" maxlength="50" :placeholder="$t('Enter name')" data-prepend="<span class='mif-pencil'></span>" />
                
            </div>

            <div class="form-group">
                <label>{{ $t("Connection Type") }}*</label>
                <select class="select cell-2 p-0" v-model="connectionType">
                    <option value="ftp">FTP</option>
                    <option value="ftps">FTPS</option>
                    <option value="iperiusstorageftp">Iperius Storage FTP</option>
                    <!--20/02/2025 : Attualmente non disponibile-->
                    <!--<option value="sftp">SFTP</option>-->
                </select>
                
            </div>

            <div class="form-group row" :disabled="connectionType == 'iperiusstorageftp'">
                <div class="cell-6 p-0 mr-3">
                   <label>{{ $t("Host name") }}*</label>
                    <input data-role="input" class="input" type="text" v-model.trim="serviceAccount.options.host" :placeholder="$t('Enter Address')"
                        data-prepend="<span class='mif-cloud'></span>" />
                     
                </div>

                <div class="cell-2 p-0">
                    <label>{{ $t("Port") }}*</label>
                    <input class="input" type="number" v-model.number="serviceAccount.port" v-number  v-range="{ min: 10, max: 65535 }"
                    :placeholder="$t('Enter Port')" />
                    
                </div>
                
            </div>

            <div class="form-group row">
                <div class="cell-6">
                    <label>{{ $t("Username") }}*</label>
                    <input data-role="input" v-model="serviceAccount.username" type="text" required
                        data-prepend="<span class='mif-person'></span>" />
                    
                </div>
                <div class="cell-6">
                    <label>{{ $t("Password") }}*</label>
                    <input v-if="[null, ''].includes(serviceAccount.id)" class="metro-input" data-role="input" type="password" v-model.trim="serviceAccount.password" :placeholder="$t('Enter Password')" v-no-autocomplete="'mif-lock'" />
                    <input v-else class="metro-input" data-role="input" type="password" data-reveal-button="false" data-prepend="<span class='mif-lock'></span>" value="**********" disabled/>
                </div>
            </div>

            <div class="form-group row" :disabled="connectionType == 'iperiusstorageftp'">
                <input data-role="checkbox" type="checkbox" :data-caption="$t('Passive Mode')"
                    data-validate="required" v-model="serviceAccount.options.passiveMode" required
                    data-prepend="<span class='mif-server'></span>" />
            </div>


            <!-------------------------------SCELTA PC----------------------------------------->
            <div v-if="$session.getRoomPC() == null" class="form-group">
                
                <SelectPCByGroup @selectPC="(pc) => { testPC = pc }" 
                    :groupLabel="$t('Select the group to which the endpoint should belong to test the {0} connection', { 0: $ONEServiceTypeInfo[serviceAccount.type].name })" 
                    :pcLabel="$t('Select an endpoint from which test the {0} connection', { 0: $ONEServiceTypeInfo[serviceAccount.type].name })" 
                    :idPC="serviceAccount.options.lastTestPC" :showSATestMsg="true" :selectIfOnline="true"
                />
            </div>
        </div>

        <!-------------------------------TEST ACCOUNT----------------------------------------->
        <div class="dialog-actions">
            <ClientMessageView :commands="['testserviceaccount', 'connectftp']" ref="CM_SA"/>
            <button class="button bg-amber" @click="test" :disabled="!enableTest" v-disable-tooltip:disabledTest_message>
                 {{ $t("Test account") }}
            </button>
            <button class="button secondary" :disabled="!enableSave" v-disable-tooltip="$t('You can save the account only if the account test is successful.')" @click="saveServiceAccount(serviceAccount)">
                {{ $t("Save") }}
            </button>
        </div>
    </div>
</template>

<script>
import DialogTitle from "../../utils/DialogTitle.vue";
import { draggableMixin } from '../../../mixins/draggable-mixin';
import SelectPCByGroup from "../../utils/SelectPCByGroup.vue";
import ClientMessageView from "../view/ClientMessageView.vue";
import { ClientMessage } from "../../../utils/objects";
import { waitSeconds } from "../../../utils/utilitiesmodule";
import { saveServiceAccount, testServiceAccount } from "../../../utils/entityMethods/serviceAccount";


export default {

    mixins: [draggableMixin],
    name: "FTPServiceAccount",
    components: {
        "DialogTitle": DialogTitle,
        SelectPCByGroup,
        ClientMessageView
    },
    props: {
        serviceAccount: Object,
    },
    data() {
        return {
            // -1 : avviato
            // 0 : non avviatoo fallito
            // 1 : ok
            connected: 0,
            testPC: null,
            // -1 : avviato
            // 0 : non avviato o fallito
            // 1 : ok
            tested: this.$ResultValue.NeverExecuted,
            disabledTest_message: "",

            connectionType: "ftp",
            //urlParts : ["ftp", "", 21]//["ftp", "", 21, ""]
        }
    },
    watch: {
        connectionType: {
            handler: function(value) {
                this.serviceAccount.options.connectionType=value;

                if (value=="iperiusstorageftp") {
                    this.serviceAccount.options.host="iperiusonlinestorage";
                    this.serviceAccount.url="ftps://iperiusonlinestorage.com";
                    this.serviceAccount.port=21;
                    this.serviceAccount.options.passiveMode=true;
                }
            }
        }
    },

    computed: {
        allInputCompleted() {

            return this.serviceAccount.name!=""&&
                (this.$session.getRoomPC()!=null||this.testPC!=null)&&
                this.serviceAccount.options.connectionType!=""&&
                this.serviceAccount.options.host!=""&&
                this.url!=""&&
                this.serviceAccount.username!=""&&
                this.serviceAccount.password!="";
        },
        enableTest() {
            if (!this.allInputCompleted) {
                this.disabledTest_message=this.$t('Insert or edit connection credentials before testing the account.');
                this.setClientMessage(ClientMessage.info_translated(this.disabledTest_message));
                return false;
            }

            switch (this.tested) {

                case this.$ResultValue.NeverExecuted:
                    if (this.serviceAccount.id!=null) {
                        this.setClientMessage(null);
                    } else {
                        this.setClientMessage(ClientMessage.info_translated(this.$t('You can save the account only if the account test is successful.')));
                    }
                    return true;

                case this.$ResultValue.Running:
                    this.disabledTest_message="";
                    return false;

                case this.$ResultValue.OK:
                    this.disabledTest_message=this.$t("Service account already validated");
                    this.setClientMessage(null);
                    return false;
                case this.$ResultValue.Error:

                    if (this.serviceAccount.id==null) {
                        this.disabledTest_message=this.$t("You can save the account only if the account test is successful.");
                        this.setClientMessage(ClientMessage.info_translated(this.disabledTest_message));
                    } else {
                        this.disabledTest_message="";
                    }

                    return true;
            }
        },
        enableSave() {
            if (!this.allInputCompleted)
                return false;

            if (this.tested==this.$ResultValue.OK)
                return true;

            if (this.tested==this.$ResultValue.Running)
                return false;

            return this.serviceAccount.id!=null
        },

        url() {
            if (this.connectionType=="iperiusstorageftp") {
                return "ftps://iperiusonlinestorage.com";
            }
            return this.serviceAccount.options.connectionType+"://"+this.serviceAccount.options.host+":"+this.serviceAccount.port
        }
    },
    created() {

        if (this.serviceAccount.options.lastTestPC!=null) {
            this.testPC=this.$session.getPCWithID(this.serviceAccount.options.lastTestPC);
        }


        if (!this.serviceAccount.options.SSLStartMode) {
            this.serviceAccount.options.SSLStartMode=0;
        }

        if (!this.serviceAccount.options.SSLProvider) {
            this.serviceAccount.options.SSLProvider=0;
        }
    },

    methods: {
        saveServiceAccount,
        testServiceAccount,

        async test() {

            this.tested=this.$ResultValue.Running;
            this.serviceAccount.url=this.url;
            var testResult=await this.testServiceAccount(this.serviceAccount, this.testPC);
            this.tested=testResult.ok? this.$ResultValue.OK:this.$ResultValue.Error;
            if (testResult.ok) {
                this.serviceAccount.options=testResult.serviceAccount.options;
            }
            //clearInterval(this.readWaitMessagetimer);

        },
        setClientMessage(clientMessage) {
            if (this.$refs.CM_SA) {
                this.$refs.CM_SA.setClientMessage(clientMessage);
            } else {
                waitSeconds(0.2).then(_ => {
                    this.$refs.CM_SA.setClientMessage(clientMessage);
                });
            }
        }
    }
}

</script>
